// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__YboIZ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2ztbv"};